import React from 'react';
import RosterTokenLock from '../../rosterTools/components/RosterTokenLock';

export default function ParticipationTokenValue({ loading, player, redacted, value }) {
  if (loading && !player) return '…';
  if (redacted) return <RosterTokenLock />;
  return value ?? '—';
}
